import React from "react";
import { Link } from "react-router-dom";
import "./CategoryProductCard.css";

function ProductCard(props){
    return(
        <div className="card mb-5">
            <img src={props.image_link} className="card-img-top" alt="nft"/>
            <div className="card-body text-center">
                <div>
                    <p className="fs-4 fw-bold">{props.price}</p>
                </div>
                <p className="card-text">{props.name}</p>
                <Link to={`/product/${props.token_id}`}>
                    <button className="button">BUY NOW</button>
                </Link>
            </div>
        </div>
    )
}

export default ProductCard;